export default __webpack_public_path__ + "static/garagem-60b00f1ef77853f8421757fc0a0fcd73.jpg";